<template>
  <div class="main__wrapper">
    <main class="mt-3">
      <h2>{{ $t('events.history') }}</h2>
      <div>
        <div v-if="loading">
          <PolygonLoader
            :centered="false"
            :size="40"
            :width="3"
          />
        </div>
        <div v-else>
          <PolygonEmptySearchResult
            v-if="noItemsFound"
            :noResultText="$t('events.noEventsFound')"
            hideIcon="true"
          />
          <ul
            class="events"
            v-else
          >
            <li
              v-for="(history, i) in items"
              :key="i"
              class="event"
            >
              <div class="event__inner">
                <div class="event__date">{{ formatDate(history.date) }}</div>
                <div>{{ history.description }}<span
                    class="debug"
                    v-if="isGlobalAdmin"
                  > [{{ history.entityName }} {{ history.id }} {{ history.type }}]</span></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import repository from '@/core/repository/entity-repository'
import entityList from '@/mixins/entity-list'
import _ from 'lodash'

export default {
  mixins: [entityList],
  activated() {
    this.loadHistory()
  },
  methods: {
    loadHistory() {
      this.loading = true
      repository
        .getHistory(this.errandId)
        .done(history => {
          this.items = history
        })
        .always(() => {
          this.loading = false
        })
    }
  },
  computed: {
    history() {
      return _.filter(this.items, item => !!item.description)
    }
  }
}
</script>

<style lang="scss" scoped>
.events {
  @include layout-list;
  @include font-size(s);
}

.debug {
  @include font-size(xs);
  font-weight: 700;
}

.event {
  position: relative; // Because line has position: absolute
  padding-bottom: measure(xxs);

  &::before {
    @include dot-connecting-line;
    top: 0;
    bottom: 0;
    left: calc(
      (#{$dot-size} - 1px) / 2
    ); // Dot size minus this width divided by two
  }

  &:last-child {
    padding-bottom: 0;

    &::before {
      bottom: 50%; // Line should not expand to the bottom (since there is no next event)
    }
  }

  .events.is-closed &:first-child::before {
    top: calc(
      50% - #{measure(xxs) / 2}
    ); // In the middle minus element padding-bottom / 2
  }
}

.event__inner {
  position: relative; // Because dot has position: absolute
  padding: measure(s);
  margin-left: measure(m);
  @include layout-box;

  &::before {
    @include dot;
    left: calc(
      #{0 - measure(m)} - 1px
    ); // Item padding-left - toggle border width
    top: 50%;
    margin-top: 0 - $dot-size / 2;
  }
}

.event__date {
  @include font-size(xs);
  color: color(medium);
}
</style>
